import React from 'react';
import PropTypes from 'prop-types';

export const FormInputGroup = ({ className, children, hidden }) => {
  const style = hidden ? { display: 'none' } : {};

  return (
    <fieldset style={style} className={className}>
      {children}
    </fieldset>
  );
};

FormInputGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  hidden: PropTypes.bool
};

